import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ModalPositionState {
    position: string | null;
    showCityModal: boolean;
    updateTurnsToFirst: boolean;
    updateClinicId: string;
    currentTurnTimeDate: {
        date: string;
        jalali?: string;
        time: string;
        childId: string | number;
    } | null;
}

const initialState: ModalPositionState = {
    position: '',
    currentTurnTimeDate: null,
    showCityModal: false,
    updateTurnsToFirst: false,
    updateClinicId: 'matab',
};

export const setPosition = createSlice({
    name: 'position_modal',
    initialState,
    reducers: {
        setFormModal: (state, action) => {
            state.position = action.payload;
        },
        setShowCityModal: (state, action) => {
            state.showCityModal = action.payload;
        },
        setUpdateTurnsToFirst: (state, action) => {
            state.updateTurnsToFirst = action.payload;
        },
        resetForm: (state) => {
            state.position = null;
        },
        setUpdateClinicId: (state, action) => {
            state.updateClinicId = action.payload;
        },
        setSelectedTurn: (
            state,
            action: PayloadAction<ModalPositionState['currentTurnTimeDate']>,
        ) => {
            state.currentTurnTimeDate = action.payload;
        },
    },
});

export const {
    setFormModal,
    resetForm,
    setSelectedTurn,
    setShowCityModal,
    setUpdateTurnsToFirst,
    setUpdateClinicId,
} = setPosition.actions;
export default setPosition.reducer;
